import { Card, Stack, Text } from '@mantine/core'

import { OutsideAnchor } from '#components/OutsideAnchor'

import styles from './SpeedTestCard.module.css'

export const SpeedTestCard = () => (
  <Card classNames={styles} mih={180} miw={200} maw={400} flex="1" w="100%">
    <Stack gap={15} justify="space-between" h="100%">
      <Text fw="bold">Internet Trouble?</Text>
      <Stack gap={0}>
        <Text>
          The problem might be your network. Measure your speed to find out.
        </Text>
      </Stack>
      <OutsideAnchor
        href="https://www.speedtest.net/"
        tracking={{
          source: 'dashboard',
          to: 'speed test',
        }}
      >
        Ookla Speedtest
      </OutsideAnchor>
    </Stack>
  </Card>
)
